const ANGLE_START = 270;

export const calculateAngles = (itemCount: number, startAngle = ANGLE_START) => {
  const angleStep = 360 / itemCount;
  return Array.from({ length: itemCount }, (_, i) => startAngle + angleStep * (i + 1));
};
